import store from '@/redux/store'
import links from '@/config/links'

const sanitizeLink = (link, { needInfo = false } = {}) => {
	if (!link) return '/'

	const { pledge: pledgeInfo, raffle: raffleInfo } = store.getState().settings

	let isModified = false
	switch (link) {
		case links.pledge.path: {
			if (pledgeInfo?.single_pledgeYN) {
				if (pledgeInfo?.route) {
					isModified = true
					link = pledgeInfo?.route
				}
			}
			break
		}

		case links.raffle.path: {
			if (raffleInfo?.single_raffleYN) {
				if (raffleInfo?.route) {
					isModified = true
					link = raffleInfo?.route
				}
			}
			break
		}

		default:
			break
	}

	if (needInfo) return { link, isModified }
	return link
}

export default sanitizeLink
